<template functional>
  <div style="align-content: center">
    <div v-for="detail in props.row.range_color_details">
      <div class="m-2" :style="`background-color:${detail.background_color}`">
        <div class="row">
          <div class="col-12 text-center" :style="`color:${detail.text_color}`">
            <strong>{{ detail.range }} - {{ detail.name }}</strong>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-center" :style="`color:${detail.text_color}`">
            <strong
              >({{ detail.from }} {{ detail.from_operator }})-({{ detail.to }}
              {{ detail.to_operator }})</strong
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RangeColorInfo',
};
</script>
<style scoped>
.responsable-info {
  padding: 10px;
  background-color: #f7f7f7;
  border-radius: 6px;
  font-size: 14px;
}

.label {
  color: #333;
}
</style>
